@if (current_user(); as user) {
  <div class="formations-toolbar">
    <button mat-flat-button color="accent" type="button" (click)="openRequestDialog()">
      <mat-icon>add</mat-icon>
      Solicitar formación
    </button>
    <a mat-stroked-button routerLink="/employees/performance/upskilling/catalog">Ir al catálogo</a>
  </div>

  <app-learning-resource-user-formation-profile [user_id]="user.id" />
}
